import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import themes from "./modules/themes";
import sounds from "./modules/sounds";
import messages from "./modules/messages";
import profiles from "./modules/profiles";
import popup from "./modules/popup";
import tab from "./modules/tab";
import drawler from "./modules/drawler";
import scroll from "./modules/scroll";
import auth from "./modules/auth";
import holder from "./modules/holder";
import orders from "./modules/orders";
import product from "./modules/product";
import websocket from "./modules/websocket";
import receptions from "./modules/receptions";
import leftovers from "./modules/leftovers";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: "stock-app-06",
  storage: localStorage,
});

const store = new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {},
  modules: {
    themes,
    sounds,
    messages,
    profiles,
    popup,
    tab,
    drawler,
    scroll,
    auth,
    holder,
    orders,
    product,
    receptions,
    leftovers,
    websocket,
  },
  mutations: {
    resetData() {
      this.commit("leftovers/setSelected", null);
      this.commit("leftovers/setItem", null);
      this.commit("leftovers/setCell", null);

      this.commit("receptions/setSelected", null);
      this.commit("receptions/setItem", null);
      this.commit("receptions/setCell", null);

      this.commit("messages/setMessages", []);
      this.commit("product/setProduct", null);
      this.commit("tab/setTab", "all");
      this.commit("popup/unsetPopup");

      this.commit("orders/setOrders", []);
    },
  },
  actions: {},
  getters: {},
});

export default store;
